import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IOffer } from './models';

interface IModal {
  isOpen: boolean;
  selectedCenter?: IOffer | null;
}

const initialState: IModal = {
  isOpen: false,
  selectedCenter: null
};

const learningCenterModal = createSlice({
  name: 'learning-center-modal',
  initialState,
  reducers: {
    openModal: (state, action: PayloadAction<IOffer | undefined>) => {
      state.isOpen = true;
      state.selectedCenter = action.payload;
    },
    closeModal: state => {
      state.isOpen = false;
      state.selectedCenter = null;
    }
  }
});

export const { openModal, closeModal } = learningCenterModal.actions;
export const learningCenterReducer = learningCenterModal.reducer;
